import React, { useRef, useState, useEffect } from 'react'
import { HeaderTabela } from '../styled'
import { Inline } from '../../../../../../../../Components/CustomUi/inline'
import Input from '../../../../../../../../Components/CustomUi/input'
import ButtonCustom from '../../../../../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBoxesPacking,
  faEllipsis,
  faFlask,
  faHouse,
  faLeaf,
  faMap,
  faPlantWilt,
  faPlus,
  faRecycle,
  faSeedling,
  faSprayCan,
  faWheatAlt,
} from '@fortawesome/free-solid-svg-icons'
import Tabs from '../../../../../../../../Components/Tabs'
import { Select } from '../../../../../../../../Components/CustomUi/Select'

interface Props {
  buscar_tabela: string
  setBuscar_tabela: React.Dispatch<React.SetStateAction<string>>
  tab_selecionar_atual: string
  setTab_selecionar_atual: React.Dispatch<React.SetStateAction<string>>
  propriedade_selecionada: string
  setPropriedade_selecionada: React.Dispatch<React.SetStateAction<string>>
  setPropriedade_selecionada_id: React.Dispatch<React.SetStateAction<number>>
  talhao_selecionado: string
  setTalhao_selecionado: React.Dispatch<React.SetStateAction<string>>
  setTalhao_selecionado_id: React.Dispatch<React.SetStateAction<number>>
  abrir: Function
  listPropriedade: any[]
  listTalhoes: any[]
}

// Pesos proporcionais de cada tab baseado no comprimento do texto
const TABS_CONFIG = [
  { descricao: 'Solo', icone: faWheatAlt, peso: 1 },
  { descricao: 'Plantas', icone: faSeedling, peso: 1.2 },
  { descricao: 'Folhas', icone: faLeaf, peso: 1.1 },
  { descricao: 'Raízes', icone: faPlantWilt, peso: 1.1 },
  { descricao: 'Microbiológica', icone: faFlask, peso: 1.7 },
  { descricao: 'Fertilizantes', icone: faBoxesPacking, peso: 1.5 },
  { descricao: 'Corretivos', icone: faSprayCan, peso: 1.3 },
  { descricao: 'Composto orgânico', icone: faRecycle, peso: 1.9 },
  { descricao: 'Outro', icone: faEllipsis, peso: 1 },
]

export const ActionsHeader: React.FC<Props> = ({
  buscar_tabela,
  setBuscar_tabela,
  tab_selecionar_atual,
  setTab_selecionar_atual,
  propriedade_selecionada,
  setPropriedade_selecionada,
  setPropriedade_selecionada_id,
  talhao_selecionado,
  setTalhao_selecionado,
  setTalhao_selecionado_id,
  abrir,
  listPropriedade,
  listTalhoes,
}) => {
  const [openPropriedade, setOpenPropriedade] = useState(false)
  const [openTalhao, setOpenTalhao] = useState(false)
  const containerRef = useRef<HTMLDivElement>(null)
  const [containerWidth, setContainerWidth] = useState(0)

  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setContainerWidth(containerRef.current.offsetWidth)
      }
    }
    updateWidth()
    window.addEventListener('resize', updateWidth)
    return () => window.removeEventListener('resize', updateWidth)
  }, [])

  /**
   * Calcula a largura de cada tab proporcionalmente
   * para preencher 100% da largura do container.
   * O padding interno do ListTabs (10px = 5px * 2) é descontado.
   */
  function calcularLarguras() {
    const larguraDisponivel = containerWidth - 10 // padding do ListTabs
    const somaPesos = TABS_CONFIG.reduce((acc, tab) => acc + tab.peso, 0)

    return TABS_CONFIG.map((tab) => ({
      descricao: tab.descricao,
      icone: tab.icone,
      width: Math.floor((tab.peso / somaPesos) * larguraDisponivel),
    }))
  }

  const tabsComLargura = calcularLarguras()

  return (
    <HeaderTabela ref={containerRef}>
      <Inline>
        <Select
          value={propriedade_selecionada}
          placeholder='Selecione a propriedade'
          icon={faHouse}
          onChange={setPropriedade_selecionada}
          onChangeID={setPropriedade_selecionada_id}
          open={openPropriedade}
          trigger={setOpenPropriedade}
          items={listPropriedade}
          descricaoItem={'nome'}
          idItem={'cod'}
        />
        <Select
          value={talhao_selecionado}
          placeholder='Selecione o talhão'
          icon={faMap}
          onChange={setTalhao_selecionado}
          onChangeID={setTalhao_selecionado_id}
          open={openTalhao}
          trigger={setOpenTalhao}
          items={listTalhoes}
          descricaoItem={'nome'}
          idItem={'cod'}
          hasTalhaoSVG
          talhaoSvgPath={['coordenadas']}
        />
        <Input placeholder='Buscar OS' value={buscar_tabela} onChange={setBuscar_tabela} />
        <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
          <ButtonCustom icon={<FontAwesomeIcon icon={faPlus} />} onClick={abrir}>
            Novo
          </ButtonCustom>
        </div>
      </Inline>
      <Tabs
        tabs={tabsComLargura}
        useTabWidth
        selecionado={tab_selecionar_atual}
        onChange={setTab_selecionar_atual}
      />
    </HeaderTabela>
  )
}
